// extracted by mini-css-extract-plugin
export var XPvideoPlayer = "VideoPlayer-module--XPvideoPlayer--1dee9";
export var XPvideoPlayerContainer = "VideoPlayer-module--XPvideoPlayerContainer--b0572";
export var playerWrapper = "VideoPlayer-module--playerWrapper--395aa";
export var playerWrapperResp = "VideoPlayer-module--playerWrapperResp--5f8dd";
export var reactPlayer = "VideoPlayer-module--reactPlayer--23f7b";
export var videoResponsive = "VideoPlayer-module--videoResponsive--b2fe1";